export const SpecificAmount = [
    { label: 'Amount', value: 'amount' },
    { label: 'Percentage', value: 'percent' },
];

export type SpecificAmountType = typeof SpecificAmount[number]['value'];